import clsx from 'clsx';

import { TableCell, TableHead, TableRow, Typography } from '@/ui';

import type { FC } from 'react';

import { VISIBLE_ASSISTANT_HEADERS } from '@/constants/assistant';

interface HeaderProps {
  headers: string[];
}

const Header: FC<HeaderProps> = ({ headers = [] }) => (
  <TableHead>
    <TableRow>
      {headers.map((header, index) => (
        <TableCell
          key={`${header}-assistant-manage-table`}
          className={clsx('md:table-cell', {
            hidden: index > VISIBLE_ASSISTANT_HEADERS,
          })}
        >
          <Typography variant="subtitle2">{header}</Typography>
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);

export default Header;
